import CreateTagContainer from "@containers/dashboard/tags/create";
import DashboardLayout from "@layouts/dashboard";

const CreateTag = () => {
    return (
        <DashboardLayout title="برچسب جدید">
            <CreateTagContainer />
        </DashboardLayout>
    );
};

export default CreateTag;
